import { render, staticRenderFns } from "./Draw.vue?vue&type=template&id=fb0be4c2&"
import script from "./Draw.vue?vue&type=script&lang=js&"
export * from "./Draw.vue?vue&type=script&lang=js&"
import style0 from "./Draw.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports